export enum SeriesCalculationMode {
  'DEFAULT',
  'CONSUMPTION_CALC',
}
